import ForumsService from '../../api/forums'

export default {
  deleteOriginalMessage: async function({ commit}, {threadId, messageId}) {
    const updatedThread = await deleteMessage({threadId, messageId})
    commit('updateThread', updatedThread)
  },
  restoreOriginalMessage: async function({ commit}, {threadId, messageId}) {
    const updatedThread = await restoreMessage( {threadId, messageId})
    commit('updateThread', updatedThread)
  },
  flagOriginalMessage: async function({commit}, {threadId, messageId, reason}) {
    await flagMessage({threadId, messageId, reason})
    commit('setThreadOriginalMessageFlagged', {threadId})
  },
  createReply: async function({commit}, {threadId, content}) {
    const response = await ForumsService.createReply(threadId, content)
    commit('setMessage', {threadId, message: response})
    return response
  },
  deleteReply: async function({commit}, {threadId, messageId}) {
    const updatedReply = await deleteMessage({threadId, messageId})
    commit('setMessage', {threadId, messageId, message: updatedReply})
  },
  restoreReply: async function({commit}, {threadId, messageId}) {
    const updatedReply = await restoreMessage({threadId, messageId})
    commit('setMessage', {threadId, messageId, message: updatedReply})
  },
  flagReply: async function({commit}, {threadId, messageId, reason}) {
    await flagMessage({threadId, messageId, reason})
    commit('setThreadReplyFlagged', {threadId, messageId})
  },
  updateThread: function({commit}, {threadId, title, content}) {
    return ForumsService.updateThread(threadId, title, content).then(({ data }) => {
      commit('updateThread', data)
    })
  },
  updateMessage: function({commit}, {threadId, messageId, content}) {
    return ForumsService.updateMessage(threadId, messageId, content).then(({ data }) => {
      commit('setMessage', {threadId, messageId, message: data})
    })
  }
}

function deleteMessage({threadId, messageId}) {
  return ForumsService.deleteMessage(threadId, messageId)
}

function restoreMessage({threadId, messageId}) {
  return ForumsService.restoreMessage(threadId, messageId)
}

function flagMessage({threadId, messageId, reason}) {
  return ForumsService.flagMessage(threadId, messageId, reason)
}

